export const SPOTLIGHT_TYPE = {
  circle: 'circle',
  rounded: 'rounded',
  rectangle: 'rectangle',
  pill: 'pill',
  button: 'button',
};
